import React from 'react';
import { FALLBACK_REGION } from '~/constants';
import { Region } from '@fx-ui/platform-sdk';

const RegionContext = React.createContext<Region>(FALLBACK_REGION);
RegionContext.displayName = 'RegionContext';

export default RegionContext;
